/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.BillingFrequency_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.BillingFrequency domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum BillingFrequency_ {
   /// <summary>
   ///   One Time (not recurring) (once)
   /// </summary>
   OneTime = 0,
   /// <summary>
   ///   Monthly (mo)
   /// </summary>
   Monthly = 1,
   /// <summary>
   ///   Quarterly (3 mo)
   /// </summary>
   Quarterly = 2,
   /// <summary>
   ///   Annually (yr)
   /// </summary>
   Annually = 4,
   /// <summary>
   ///   Scheduled (definite dates) (sched)
   /// </summary>
   Scheduled = 5,
   /// <summary>
   ///   Partner Billed (pbill)
   /// </summary>
   PartnerBilled = 99
}

export const BillingFrequencies: BillingFrequency[] = [
   {
      code: BillingFrequency_.OneTime,
      literal: 'OneTime',
      description: 'One Time (not recurring)',
      shortDescription: 'once',
      listPriority: 0,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.Monthly,
      literal: 'Monthly',
      description: 'Monthly',
      shortDescription: 'mo',
      listPriority: 0,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.Quarterly,
      literal: 'Quarterly',
      description: 'Quarterly',
      shortDescription: '3 mo',
      listPriority: 0,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.Annually,
      literal: 'Annually',
      description: 'Annually',
      shortDescription: 'yr',
      listPriority: 0,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.Scheduled,
      literal: 'Scheduled',
      description: 'Scheduled (definite dates)',
      shortDescription: 'sched',
      listPriority: 0,

      typeName: "BillingFrequency"
   },
   {
      code: BillingFrequency_.PartnerBilled,
      literal: 'PartnerBilled',
      description: 'Partner Billed',
      shortDescription: 'pbill',
      listPriority: 0,

      typeName: "BillingFrequency"
   }
]

export class BillingFrequency implements IDomainModel {
   code: BillingFrequency_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: BillingFrequency_): BillingFrequency {
      return BillingFrequencies.find(d => d.code === code)
   }
}
